import { ComponentMap } from '@cinch-nx/data-storyblok'
import { sharedStoryblokComponents } from '@cinch-nx/storyblok'
import Video from '../video/video'
import {
  AuthorByline,
  CtaButton,
  FaqSection,
  FeatureCard,
  FeatureImageCard,
  HeroCtaButton,
  HighlightsSection,
  IntroSection,
  TextInlineImage,
  TextInlineImageSection,
} from './blocks'

const landingStoryblokComponents: ComponentMap = {
  AuthorByline,
  CtaButton,
  FaqSection,
  FeatureCard,
  FeatureImageCard,
  HeroCtaButton,
  HighlightsSection,
  IntroSection,
  LandingTextInlineImage: TextInlineImage,
  LandingTextInlineImageSection: TextInlineImageSection,
  YoutubeVideo: Video,
}

export const storyblokComponents: ComponentMap = {
  ...sharedStoryblokComponents,
  ...landingStoryblokComponents,
}
